import MobileDevicesList from './MobileDevicesList';

export default MobileDevicesList;
